export interface User {
    id: string;
    username: string;
    name: string;
    role: 'admin' | 'dashboard-viewer' | 'station-admin';
    permissions: string[];
    stationAccess?: string[]; // 可访问的站点
}

export interface LoginForm {
    username: string;
    password: string;
}

// 演示用户数据
export const DEMO_USERS: User[] = [
    {
        id: '1',
        username: 'admin',
        name: '系统管理员',
        role: 'admin',
        permissions: ['all'],
        stationAccess: ['all']
    },
    {
        id: '2',
        username: 'dashboard',
        name: '数据大屏用户',
        role: 'dashboard-viewer',
        permissions: ['dashboard:view'],
        stationAccess: ['all']
    },
    {
        id: '3',
        username: 'windfarm-a',
        name: '风电场A管理员',
        role: 'station-admin',
        permissions: [
            'historical-data:view',
            'weather-prediction:view',
            'model-management:manage',
            'power-prediction:manage',
            'dashboard:view'
        ],
        stationAccess: ['风电场A-1号机组', '风电场A-2号机组']
    }
];

export const USER_PASSWORDS: Record<string, string> = {
    'admin': 'admin123',
    'dashboard': 'dashboard123',
    'windfarm-a': 'windfarm123'
}; 